import $ from 'jquery';

import { Direction } from 'webapp/enums/enums';
import { TourId } from 'webapp/enums/tour';
import { UserSettingsKey } from 'webapp/enums/user-settings';

import type { StepData } from 'webapp/models-custom/tour';
import TourBase from 'webapp/models-custom/tour';

export default class ReportsChangeDataStorySettingsTour extends TourBase {
	static keyForPersistantDone = UserSettingsKey.REPORTS_CHANGE_DATA_STORY_SETTINGS;

	get id(): string {
		return TourId.REPORTS__CHANGE_DATA_STORY_SETTINGS;
	}

	override get keyForPersistantDone(): string {
		return ReportsChangeDataStorySettingsTour.keyForPersistantDone;
	}

	override get stepData(): StepData[] {
		return [
			{
				direction: Direction.RIGHT,
				allowStacked: false,
				attachTo: () => {
					return $('story-element').eq(0);
				},
			},
		];
	}
}
